import React, { useState } from 'react'
import './App.css'
import Login from './components/Login'

function App() {
  const [isConnected, setIsConnected] = useState(false)
  const [walletAddress, setWalletAddress] = useState('')

  const handleWalletConnect = (address) => {
    setIsConnected(true)
    setWalletAddress(address)
  }

  return (
    <div className="app">
      {!isConnected ? (
        <Login onConnect={handleWalletConnect} />
      ) : (
        <div className="dashboard">
          <h1>Welcome to Integrity Farm</h1>
          <p>Connected: {walletAddress}</p>
        </div>
      )}
    </div>
  )
}

export default App